import * as actionType from './actionTypes';
import { API_URL, API_HEADERS } from '../../constants/api';
import { apiRequest, apiBatchRequest } from '../../utils/api_service';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';

export const getUserData = (query) => dispatch => {
  apiRequest(
    {
      url: API_URL.Users.GetUserOrganizationDetails
    }
  ).then(({ data: response }) => {
    const cloudOrg = ((response || [])[0] || {});
    localStorage.setItem(
      API_HEADERS.CID, cloudOrg.cloudOrgId
    );
    apiBatchRequest([
      {
        url: API_URL.Users.GetUserConfigurations + '?periodStartDate=' + moment().format(DateFormat),
        key: 'userData'
      }
    ]).then(({ userData }) => {
      dispatch({
        type: actionType.GET_USER_DATA,
        payload: userData.updateData
      });
    });
  });
};

export const setNotificationData = (query) => dispatch => {
  return dispatch({
    type: actionType.SET_NOTIFICATION_DATA,
    payload: query
  });
};
export const setLoadingScreen = isLoading => dispatch => {
  return dispatch({
    type: actionType.SET_LOADER_SCREEN,
    payload: isLoading
  });
};
